import { cn } from '@avanta/shared/utils/cn';
import { Star } from 'lucide-react';
import { type ReactElement, useState } from 'react';
import { type RatingStarsProps } from './types';

export const RatingStars = ({
  value,
  onChange,
  maxStars = 5,
  disabled = false,
}: RatingStarsProps): ReactElement => {
  const [hoveredRating, setHoveredRating] = useState(0);

  return (
    <div className="flex gap-2 justify-center">
      {Array.from({ length: maxStars }, (_, index) => index + 1).map(star => (
        <button
          key={star}
          type="button"
          onClick={() => !disabled && onChange(star)}
          onMouseEnter={() => !disabled && setHoveredRating(star)}
          onMouseLeave={() => setHoveredRating(0)}
          disabled={disabled}
          className={cn(
            'transition-transform hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded',
            disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          <Star
            className={cn(
              'h-8, w-8 transition-colors',
              (hoveredRating || value) >= star ? 'fill-teal-600 text-teal-600' : 'text-gray-600'
            )}
          />
        </button>
      ))}
    </div>
  );
};
